import React from 'react';

class LoadingHeader extends React.Component {
  render() {
    return (
      <p>Carregando...</p>
    );
  }
}

export default LoadingHeader;
